<template>
  <div class="page-shell">
    <!-- Lista de atendimentos -->
    <v-list subheader two-line>
      <v-card class="page-toolbar" flat>
        <b-row>
          <b-col cols="3">
            <v-text-field
              label="Data Inicial"
              placeholder="Não informado"
              filled
              dark
              hide-details="auto"
              v-model="filtro_data"
              type="date"
            ></v-text-field>
          </b-col>
          <b-col cols="3">
            <v-text-field
              label="Data Final"
              placeholder="Não informado"
              filled
              dark
              hide-details="auto"
              v-model="filtro_data_f"
              type="date"
            ></v-text-field>
          </b-col>
          <b-col cols="2">
            <v-select
              v-model="filtro_tipo"
              :items="Enum.situacao"
              dark
              outlined
              label="Tipo do chamado"
              hide-details="auto"
              item-text="text"
              item-value="val"
              no-data-text="Nenhuma Informação disponível"
            ></v-select>
          </b-col>
          <b-col cols="3">
            <AutoBusca
              id="cliente"
              item_id="id"
              item_text="nome"
              item_campos="cli.id as id, cli.id|| ' - ' ||cli.nome || ' - ' || cli.cnpj || ' ('||TRIM(cid.nome)||'/'||cid.uf||')' as nome"
              item_busca="cli.id|| '-' || TRIM(UPPER(cli.nome))|| '-' || TRIM(UPPER(cli.cnpj)) "
              item_left="LEFT JOIN cidade cid ON cid.codcid=cli.codcid"
              tabela="cliente cli"
              :value="filtro_id_cli"
              @getID="getID"
              :label="'Digite o cliente'"
              :rdark="true"
            />

            <!-- <AutoBusca
                        id="cliente"
                        item_id="id"
                        item_text="nome"
                        item_campos="cli.id as id, cli.id|| ' - ' ||cli.nome || ' - ' || cli.cnpj || ' ('||TRIM(cid.nome)||'/'||cid.uf||')' as nome, cli.cnpj"
                        item_busca="cli.id|| '-' || TRIM(UPPER(cli.nome))|| '-' || TRIM(UPPER(cli.cnpj)) "
                        item_left="LEFT JOIN cidade cid ON cid.codcid=cli.codcid"
                        tabela="cliente cli"
                        :value="file.id_cli"
                        @getID="getID"
                        :label="'Digite o cliente'"
                      /> -->
          </b-col>
          <b-col cols="1" :style="{ 'align-self': 'center' }">
            <v-btn icon dark @click="chamarFiltroData">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
            <v-btn
              icon
              dark
              v-if="expand_mais == true"
              @click="expand_mais = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-btn icon dark v-else @click="expand_mais = true">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </b-col>
        </b-row>
        <b-row v-if="expand_mais">
          <b-col cols="3">
            <AutoBusca
              id="tecnico"
              item_id="id"
              item_text="nome"
              item_campos="tec.id as id, tec.nome as nome"
              item_busca="tec.id::char|| '-' || TRIM(UPPER(tec.nome)) "
              item_left=""
              tabela="tecnico tec"
              :value="filtro_tecnico"
              @getID="getID"
              :label="'Tecnico do atendimento'"
              :rdark="true"
            />
          </b-col>
          <b-col cols="3">
            <AutoBusca
              id="tecnico_resp"
              item_id="id"
              item_text="nome"
              item_campos="tec.id as id, tec.nome as nome"
              item_busca="tec.id::char|| '-' || TRIM(UPPER(tec.nome)) "
              item_left=""
              tabela="tecnico tec"
              :value="filtro_tecnico_resp"
              @getID="getID"
              :label="'Tecnico responsável'"
              :rdark="true"
            />
          </b-col>
        </b-row>
      </v-card>

      <v-tabs v-model="tab" class="page-tabs">
        <v-tab v-for="item in items" :key="item.tab" :class="item.color">
          <small>
            {{ item.tab + (item.nro == 0 ? "" : "(" + item.nro + ")") }}</small
          >
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <GridChamados
            :files="files_1"
            :filtro_color="filtro_color_1"
            tipoc="1"
            :tecnicos="tecnicos"
            @confirmouChamado="confirmouChamado"
          />
        </v-tab-item>
        <v-tab-item>
          <GridChamados
            :files="files_U"
            :filtro_color="filtro_color_U"
            tipoc="U"
            :tecnicos="tecnicos"
            @confirmouChamado="confirmouChamado"
          />
        </v-tab-item>
        <v-tab-item>
          <GridChamados
            :files="files_P"
            :filtro_color="filtro_color_P"
            tipoc="P"
            :tecnicos="tecnicos"
            @confirmouChamado="confirmouChamado"
          />
        </v-tab-item>
        <v-tab-item>
          <GridChamados
            :files="files_S"
            :filtro_color="filtro_color_S"
            tipoc="S"
            :tecnicos="tecnicos"
            @confirmouChamado="confirmouChamado"
            :lista="true"
            :colunas="coluna_visita"
          />
        </v-tab-item>
        <v-tab-item>
          <GridChamados
            :files="files_3"
            :filtro_color="filtro_color_3"
            tipoc="3"
            :tecnicos="tecnicos"
            @confirmouChamado="confirmouChamado"
          />
        </v-tab-item>
        <v-tab-item>
          <GridChamados
            :files="files_5"
            :filtro_color="filtro_color_5"
            tipoc="5"
            :tecnicos="tecnicos"
            @confirmouChamado="confirmouChamado"
          />
        </v-tab-item>
        <v-tab-item>
          <GridChamados
            :files="files_6"
            :filtro_color="filtro_color_6"
            tipoc="6"
            :tecnicos="tecnicos"
            @confirmouChamado="confirmouChamado"
          />
        </v-tab-item>
        <v-tab-item>
          <GridChamados
            :files="files_8"
            :filtro_color="filtro_color_8"
            tipoc="8"
            :tecnicos="tecnicos"
            @confirmouChamado="confirmouChamado"
            :lista="true"
          />
        </v-tab-item>
        <v-tab-item>
          <GridChamados
            :files="files_F"
            :filtro_color="filtro_color_F"
            tipoc="F"
            :tecnicos="tecnicos"
            @confirmouChamado="confirmouChamado"
          />
        </v-tab-item>
        <v-tab-item>
          <Calendario></Calendario>
          <!-- <GridChamados :files="files_C" :filtro_color="filtro_color_C" /> -->
        </v-tab-item>
        <v-tab-item>
          <!-- <GridChamados :files="files_D" :filtro_color="filtro_color_D" /> -->
        </v-tab-item>
        <v-tab-item>
          <!-- <GridChamados :files="files_N" :filtro_color="filtro_color_N" /> -->
        </v-tab-item>
      </v-tabs-items>
    </v-list>

    <!-- Dialogo dos filtros -->
    <v-dialog
      v-model="modal_calendar"
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="modal_calendar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="buscaChamados"> Buscar </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-date-picker v-model="filtro_data" locale="pt-br"></v-date-picker>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Chamado from "../domain/Chamado.js";
import GridChamados from "../components/GridChamados.vue";
import AutoBusca from "../components/AutoBusca.vue";
import _Enum from "../obj/Enum";
import { mapState, mapActions } from "vuex";
import Calendario from "../components/Calendar.vue";

export default {
  components: {
    GridChamados,
    AutoBusca,
    Calendario,
  },
  data: () => ({
    Enum: _Enum,
    tipo_filtro: [],
    fab: false,
    tecnicos: [],
    files: [],
    file: {},
    files_1: [],
    filtro_color_1: "yellow lighten-4",
    files_U: [],
    filtro_color_U: "red lighten-4",
    files_3: [],
    filtro_color_3: "green lighten-4",
    files_5: [],
    filtro_color_5: "orange lighten-4",
    files_6: [],
    filtro_color_6: "purple lighten-4",
    files_8: [],
    filtro_color_8: "blue lighten-4",
    files_S: [],
    filtro_color_S: "indigo lighten-4",
    files_F: [],
    filtro_color_F: "",
    files_P: [],
    filtro_color_P: "grey lighten-1",
    files_C: [],
    filtro_color_C: "",
    files_D: [],
    filtro_color_D: "",
    files_N: [],
    filtro_color_N: "",
    data_calendar: "",
    modal_calendar: false,
    zIndex: 0,
    items_menu: [
      { id: 0, title: "Contatos" },
      { id: 1, title: "Conexões" },
      { id: 2, title: "Resoluções" },
      { id: 3, title: "Editar" },
      { id: 4, title: "Cutucar" },
    ],
    filtro_atendimentos: "Diversos",
    filtro_color: "yellow lighten-4",
    sheet_contatos: false,
    filtro_tipo: "",
    expand_mais: false,
    filtro_resolvido: false,
    filtro_id_cli: "",
    filtro_tecnico: "",
    filtro_tecnico_resp: "",
    filtro_data: null,
    filtro_data_f: null,
    filtraChamados: "",
    tab: 0,
    items: [
      {
        tab: "Diversos",
        situacao: "1",
        finalizado: false,
        nro: 0,
        color: "yellow lighten-4",
      },
      {
        tab: "Urgente",
        situacao: "U",
        finalizado: false,
        nro: 0,
        color: "red lighten-4",
      },
      {
        tab: "Plantão",
        situacao: "P",
        finalizado: false,
        nro: 0,
        color: "grey lighten-1",
      },
      {
        tab: "Novas Instalações",
        situacao: "S",
        finalizado: false,
        nro: 0,
        color: "indigo lighten-4",
      },
      {
        tab: "Alterações SAGE",
        situacao: "3",
        finalizado: false,
        nro: 0,
        color: "green lighten-4",
      },
      {
        tab: "Vendas",
        situacao: "5",
        finalizado: false,
        nro: 0,
        color: "orange lighten-4",
      },
      {
        tab: "Visitas",
        situacao: "6",
        finalizado: false,
        nro: 0,
        color: "purple lighten-4",
      },
      {
        tab: "Projetos WEB",
        situacao: "8",
        finalizado: false,
        nro: 0,
        color: "blue lighten-4",
      },
      {
        tab: "Finalizados",
        situacao: "",
        finalizado: true,
        nro: 0,
        color: "white",
      },
      
    ],
    timer: null,
    tempoTimer: 600000, 
    coluna_visita: [
      {
        name: "Solicitado",
        id: 0,
        status: ["open", "fila"],
        columnItems: [],
        /*  validation: (src, payload, index, origins) =>
           this.columnValidation(src, payload, index, (origins = ["review", "test", "closed"])), */
      },
      {
        name: "Instalando",
        id: 1,
        status: ["executing", "review", "paralised"],
        columnItems: [],
        /* validation: (src, payload, index, origins) =>
          this.columnValidation(
            src,
            payload,
            index,
            (origins = ["open", "paralised"])
          ), */
      },
      {
        name: "Em treinamento",
        id: 2,
        status: ["testando", "test"],
        columnItems: [],
        /*  validation: (src, payload, index, origins) =>
           this.columnValidation(
             src,
             payload,
             index,
             (origins = ["executing", "review"])
           ), */
      },
      {
        name: "Finalizado",
        id: 3,
        status: ["finished", "closed"],
        columnItems: [],
        /*  validation: (src, payload, index, origins) =>
           this.columnValidation(
             src,
             payload,
             index,
             (origins = ["test", "closed","open"])
           ), */
      },]
  }),
  computed: {
    ...mapState("Usuarios", ["filtros_chamado"]),
  },
  created() {
    /* var vm = this;
    this.timer = setInterval(function () {
      vm.buscaChamados(2);
    }, this.tempoTimer); */

    this.tipo_filtro = this.Enum.situacao;
    this.tipo_filtro.unshift({ text: "Todos", val: "" });
  },
  mounted() {
    this.tab = this.tabChamadosIdx;
    this.filtro_data = Vue.getDataInput();
    this.filtro_data_f = Vue.getDataInput();
    this.buscaChamados(1);
  },
  watch: {
    /*     filtros_chamado: function (val) {
      this.tab = val.tabChamadosIdx;
      this.filtro_data = val.filtro_data;
      this.filtro_data_f = val.filtro_data_f;
      this.filtro_tipo = val.situacao;
      this.filtro_id_cli = val.id_cliente;
      this.filtro_tecnico = val.id_tec_inicial;
      this.filtro_tecnico_resp = val.id_tec_resp;
    }, */
  },
  methods: {
    ...mapActions("Usuarios", ["setFiltrosChamados"]),
    getID(val) {
      if (val.id == "cliente") {
        this.filtro_id_cli = val.value;
        //this.chamarFiltroData();
        //this.setFiltrosChamados(this.getFiltrosChamados());
      }

      if (val.id == "tecnico") {
        this.filtro_tecnico = val.value;
        //this.chamarFiltroData();
        //this.setFiltrosChamados(this.getFiltrosChamados());
      }

      if (val.id == "tecnico_resp") {
        this.filtro_tecnico_resp = val.value;
        //this.chamarFiltroData();
        //this.setFiltrosChamados(this.getFiltrosChamados());
      }
    },
    chamarFiltroData() {
      this.buscaChamados(1);
    },
    testaMenu(chamado, menu) {
      this.file = chamado;
      if (menu.id == 0) {
        this.verContato(chamado);
      }
    },
    confirmouChamado() {
      this.buscaChamados(1);
    },
    verContato() {
      this.sheet_contatos = true;
    },
    buscaChamados(load) {
      this.modal_calendar = false;
      this.filtro_atendimentos = "";
      this.filtro_color = "";
      this.files = [];

      var rgetTecnico = false;
      if (this.tecnicos.length <= 0) rgetTecnico = true;

      if (load == 1) Vue.Loading("Atualizando chamados...", "", this);
      this.service = new Chamado(this.$resource);
      this.service
        .get(
          this.filtro_data,
          this.filtro_tecnico_resp,
          this.filtro_tipo,
          this.filtro_tecnico,
          this.filtro_id_cli,
          this.filtro_data_f,
          rgetTecnico
        )
        .then(
          function (tmp) {
            console.log("chamado");
            if (this.tecnicos.length <= 0) this.tecnicos = tmp.tec;
            this.files_1 = [];
            this.files_U = [];
            this.files_P = [];
            this.files_3 = [];
            this.files_5 = [];
            this.files_6 = [];
            this.files_S = [];
            this.files_8 = [];
            this.files_F = [];
            this.files = tmp.cha;

            this.files_1 = tmp.cha.filter(function (e) {
              return e.tipo == "1" && e.resolvido == false ? e : null;
            });
            this.items[0].nro = this.files_1.length;
            this.files_U = tmp.cha.filter(function (e) {
              return e.tipo == "U" && e.resolvido == false ? e : null;
            });
            this.items[1].nro = this.files_U.length;

            this.files_P = tmp.cha.filter(function (e) {
              return e.tipo == "P" && e.resolvido == false ? e : null;
            });
            this.items[2].nro = this.files_P.length;

            this.files_3 = tmp.cha.filter(function (e) {
              return e.tipo == "3" && e.resolvido == false ? e : null;
            });
            this.items[4].nro = this.files_3.length;

            this.files_5 = tmp.cha.filter(function (e) {
              return e.tipo == "5" && e.resolvido == false ? e : null;
            });
            this.items[5].nro = this.files_5.length;

            this.files_6 = tmp.cha.filter(function (e) {
              return e.tipo == "6" && e.resolvido == false ? e : null;
            });
            this.items[6].nro = this.files_6.length;

            this.files_S = tmp.cha.filter(function (e) {
              return e.tipo == "S" && e.resolvido == false ? e : null;
            });
            this.items[3].nro = this.files_S.length;

            this.files_8 = tmp.cha.filter(function (e) {
              return e.tipo == "8" && e.resolvido == false ? e : null;
            });
            this.items[7].nro = this.files_8.length;

            this.files_F = tmp.cha.filter(function (e) {
              return e.resolvido == true ? e : null;
            });
            this.items[8].nro = this.files_F.length;

            if (load == 1) Vue.CloseLoading(this);
          },
          (err) => {
            if (load == 1) Vue.CloseLoading(this);
            console.log(err);
            //Vue.alertDanger(err, this);
          }
        );
    },
    chamarCliente() {
      //var link_whats = "https://api.whatsapp.com/send?phone=" + contatoWhats + "&text=" + MobileUI.retormaMsgWhats();
      //window.location.href = link_whats;
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    getFiltrosChamados() {
      return {
        tabChamadosIdx: this.tab,
        data_ini: this.filtro_data,
        data_fin: this.filtro_data_f,
        situacao: this.filtro_tipo,
        id_cliente: this.filtro_id_cli,
        id_tec_inicial: this.filtro_tecnico,
        id_tec_resp: this.filtro_tecnico_resp,
      };
    },
  },
  beforeDestroy() {
    //this.cancelAutoUpdate();
  },
  destroyed() {
    this.cancelAutoUpdate();
  },
};
</script>

<style>
</style>
